import { getFormValues } from 'redux-form';
import { createSelector } from 'reselect';
import { getLastUsedEmailIntegration } from '../../../../app/utils/reselect';
import { FORM_NAME } from '../components/ComposeEmailModal';
const initialValues = (state) => state.composeEmail.initialValues;
const getOrganizationStorage = (_state, organizationStorage) => organizationStorage;
export const selectInitialValues = createSelector([
    initialValues,
    getFormValues(FORM_NAME),
    getLastUsedEmailIntegration,
    getOrganizationStorage,
], (initialValues, formValues, lastUsedEmailIntegration, organizationStorage) => {
    if (!initialValues ||
        (!initialValues.fromEmails && lastUsedEmailIntegration)) {
        initialValues = initialValues || Object.assign({}, formValues);
        // If no fromEmail is set, we use the last used from email if the feature flag is enabled.
        if (organizationStorage !== undefined && // organization storage is loaded
            (organizationStorage.autofill_email_from === undefined ||
                organizationStorage.autofill_email_from === true)) {
            initialValues.fromEmails = lastUsedEmailIntegration;
        }
    }
    return initialValues;
});
